import React from "react";
import {
    BarChart,
    Bar,
    XAxis,
    YAxis,
    CartesianGrid,
    Tooltip,
    Legend,
    ResponsiveContainer
} from "recharts";

interface IProps {
    Data: any;
    Stacked?: boolean;
    Bar_one?: {
        name: string;
        backgroundColor: string;
        size?: number;
        dataKey_in_data?: string;
    }
    Bar_two?: {
        name: string;
        backgroundColor: string;
        size?: number;
        datakey_in_data?: string;
    }
    Tooltip_styles?: {};
    Bottom_Color_Details_Hide?: boolean;
    Data_range?: number[];
    Horizontal_Lines?: boolean;
    Vertical_Lines?: boolean;
    Hide_XAxisLine?: boolean;
    Hide_YAxisLine?: boolean;
    Horizontal_Lines_Dashed?: boolean;
    Vertical_Lines_Dashed?: boolean;

}

const StaticticsBarGraph: React.FC<IProps> = (Props: IProps) => {
    return (
        <ResponsiveContainer width="100%" height={"100%"}>
            <BarChart
                width={500}
                height={300}
                data={Props.Data}
                margin={{ top: 20, right: 40, left: 0, bottom: 0 }}
            >
                <CartesianGrid vertical={Props.Vertical_Lines || false} horizontal={Props.Horizontal_Lines || false} strokeDasharray={(Props.Horizontal_Lines_Dashed || Props.Vertical_Lines_Dashed) ? 3 : ""} />
                <XAxis
                    axisLine={!Props.Hide_XAxisLine}
                    dataKey="date"
                    type="category"
                    // tick={{ fill: "#e5e7eb" }}
                    tickLine={{ stroke: "#e5e7eb" }}
                />
                <YAxis
                    axisLine={!Props.Hide_YAxisLine}
                    ticks={Props.Data_range}
                    // tick={{ fill: "#e5e7eb" }}
                    tickLine={{ stroke: "#e5e7eb" }}
                />
                <Tooltip
                    contentStyle={Props.Tooltip_styles ? Props.Tooltip_styles : {
                        backgroundColor: "#fff",
                        color: "black",
                        fontWeight: "bold",
                        borderRadius:"4px"
                    }}
                />
                {!Props.Bottom_Color_Details_Hide &&
                    <Legend wrapperStyle={{ fontWeight: "bold", fontSize: "11px" }}
                    />
                }
                <Bar dataKey="OpenTickets" stackId="a" fill={Props.Bar_one?.backgroundColor || "#0155C4"} name={Props.Bar_one?.name} barSize={Props.Bar_one?.size || 55} />
                <Bar dataKey="ClosedTickets" stackId={Props.Stacked ? "a" : "b"} fill={Props.Bar_two?.backgroundColor || "#DBBE00"} name={Props.Bar_two?.name} barSize={Props.Bar_two?.size || 55} />
            </BarChart>
        </ResponsiveContainer>
    )
}

export default StaticticsBarGraph;